<dx-text-box
  class="flex-grow-1 np-highlight"
  style="width: 450px;"
  label="{{ 'Festwert' | translate }}"
  placeholder="{{ 'Wert vorgeben' | translate }}"
  [(value)]="templateItem.defaultValue"
  (onValueChanged)="onUpdate.emit()"
></dx-text-box>
